import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';
import {AuthService} from '../_services/auth.service';
import {filter, map, take} from 'rxjs/operators';
import {combineLatest} from 'rxjs';

export const authGuard = (route: any) => {
  const oauthService = inject(OAuthService);
  const router = inject(Router);
  const authService = inject(AuthService);

  // ✅ Wait until auth is done loading before making a decision
  return combineLatest([
    authService.isDoneLoading$,
    authService.isAuthenticated$
  ]).pipe(
    filter(([isDone]) => isDone), // wait until loading is complete
    take(1),
    map(([isDone, isAuthenticated]) => {
      if (!isAuthenticated) {
        oauthService.initLoginFlow();
        return false;
      }

      const userProfile = authService.userProfile$;
      const requiredPermissions = route.data?.['permissions'];

      if (!authService.isAdmin && Array.isArray(requiredPermissions)) {
        const permissions = authService['userProfileSubject$']?.value?.permissions ?? [];
        const allowed = requiredPermissions.some(p => permissions.includes(p));
        if (!allowed) router.navigate(['/']);
        return allowed;
      }

      return true;
    })
  );
};
